import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const INCIDENTCATEGORY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.IncidentCategory.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const INCIDENTCATEGORY_CONFIG = {
  entityName: 'IncidentCategory',
  localizationKey: 'Planning::Entity.IncidentCategory',
  fields: INCIDENTCATEGORY_FIELDS,
  permission: 'ResearchAndDevelopmentIncident.IncidentCategories',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Incident + MENU_NAME_SUFFIX,
};
